import Link from 'next/link';
import homepageTranslations from '@/lib/homepageTranslations.json';

interface FinalCTASectionProps {
  currentLang?: 'sl' | 'en';
}

export default function FinalCTASection({ currentLang = 'sl' }: FinalCTASectionProps) {
  const lang = currentLang === 'en' ? 'en' : 'sl';
  const content = {
    title: homepageTranslations.finalCta.title[lang],
    ctaProducts: homepageTranslations.finalCta.ctaProducts[lang],
    ctaServices: homepageTranslations.finalCta.ctaServices[lang],
  };

  return (
    <section className="py-32 px-6 md:px-10 bg-accent/30">
      <div className="max-w-4xl mx-auto text-center space-y-12">
        <h2 className="text-4xl md:text-5xl font-bold tracking-tighter leading-tight">
          {content.title}
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link href="/products" className="btn-primary">
            {content.ctaProducts}
          </Link>
          <Link href="/services" className="btn-secondary">
            {content.ctaServices}
          </Link>
        </div>
      </div>
    </section>
  );
}
